import React, { useEffect, useRef, useState } from "react";
import { Table, Button } from "react-bootstrap";
import Layout from "../../components/Layout";
import { useNavigate } from "react-router-dom";
import { MdModeEdit, MdDelete } from "react-icons/md";
import ToastFile from "../../utils/ToastFile";
import { deleteRouteByID, getAllRoutebyContractor } from "../../api/RouteApi";
import DeleteModel from "../../components/DeleteModel";
import Loader from "../../components/Loader";
import { FaEye, FaFileUpload, FaUpload } from "react-icons/fa";

const RouteInfo = () => {
  const [routes, setRoutes] = useState([]);
  const fetched = useRef(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(0);
  const [isLoading, setIsloading] = useState(true);

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    getRoute();
  }, []);

  const getRoute = () => {
    setIsloading(true);
    getAllRoutebyContractor(user.tenant_id)
      .then((res) => {
        if (res.status === 200) {
          setRoutes(res?.data?.data?.routes);
        } else {
          ToastFile("Failed to fetch routes", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching routes:", err);
        ToastFile("Error fetching routes", "error");
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  const openAddModal = () => {
    navigate("/routeInfo/add");
  };

  const openEditModal = (index) => {
    const route = routes[index];
    navigate("/routeInfo/edit", {
      replace: true,
      state: { route },
    });
  };

  const openPanelAddress = (index) => {
    const route = routes[index];
    navigate("/routeInfo/paneladdress", {
      replace: true,
      state: { route },
    });
  };

  const deleteRoute = () => {
    deleteRouteByID(routes[deleteIndex]._id)
      .then((res) => {
        if (res.status === 200) {
          ToastFile("Route deleted", "deleted");
          fetched.current = false;
          getRoute();
        } else {
          ToastFile("Failed to delete route", "error");
        }
      })
      .catch((err) => {
        console.error("Error deleting route:", err);
        ToastFile("Error deleting route", "error");
      })
      .finally(() => {
        setDeleteIndex(0);
        setDeleteModal(false);
      });
  };

  return (
    <Layout>
      <DeleteModel
        showModal={deleteModal}
        setShowModal={setDeleteModal}
        onYes={deleteRoute}
      />
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-3">
        <h3 className="mb-0">Routes</h3>
        <Button onClick={openAddModal} className="bg-dark">
          + Add Route
        </Button>
      </div>

      {/* Table Section - Mobile Responsive */}
      <div className="table-responsive d-none d-md-block">
        <Table striped bordered hover className="table-sm">
          <thead className="table-dark">
            <tr style={{ textAlign: "center" }}>
              <th className="text-nowrap">Route No</th>
              <th className="text-nowrap">Route Name</th>
              <th className="text-nowrap d-none d-lg-table-cell">
                Contractor No
              </th>
              {/* <th className="text-nowrap d-none d-lg-table-cell">
                Panel Address
              </th> */}
              <th className="text-nowrap">Actions</th>
            </tr>
          </thead>
          {isLoading ? (
            <tbody>
              <tr>
                <td colSpan="5">
                  <Loader />
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {routes.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center">
                    No route found
                  </td>
                </tr>
              ) : (
                routes.map((c, idx) => (
                  <tr key={idx}>
                    <td className="text-nowrap">
                      <div className="fw-bold" style={{ textAlign: "center" }}>
                        {c.distance}
                      </div>
                    </td>
                    <td className="text-nowrap">{c.routeName}</td>
                    <td className="text-nowrap d-none d-lg-table-cell">
                      {c.description}
                    </td>
                    {/* <td className="text-nowrap" style={{ textAlign: "center" }}>
                      <button
                        className="btn btn-sm btn-outline-secondary border-0"
                        onClick={() => openPanelAddress(idx)}
                        title="View"
                      >
                        <FaEye size={16} />
                      </button>
                     
                    </td> */}
                    <td className="text-nowrap" style={{ textAlign: "center" }}>
                      <button
                        className="btn btn-sm btn-outline-primary border-0"
                        onClick={() => openEditModal(idx)}
                        title="Edit"
                      >
                        <MdModeEdit size={16} />
                      </button>
                      <button
                        className="btn btn-sm btn-outline-danger border-0"
                        onClick={() => {
                          setDeleteIndex(idx);
                          setDeleteModal(true);
                        }}
                        title="Delete"
                      >
                        <MdDelete size={16} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          )}
        </Table>
      </div>

      {/* Mobile Card View for Small Screens */}
      <div className="d-md-none">
        {routes.length === 0 ? (
          <div className="text-center py-4">
            <p className="text-muted">No route found</p>
          </div>
        ) : (
          <div className="row g-3">
            {routes.map((c, idx) => (
              <div key={idx} className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div className="flex-grow-1">
                        <h6 className="card-title mb-1">{c.routeName}</h6>
                        <small className="text-muted d-block">
                          Route No: {c.distance}
                        </small>
                      </div>
                      <div className="d-flex gap-1">
                         <button
                        className="btn btn-sm btn-outline-secondary "
                        onClick={() => openPanelAddress(idx)}
                        title="View"
                      >
                        <FaEye size={16} />
                      </button>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => openEditModal(idx)}
                          title="Edit"
                        >
                          <MdModeEdit size={16} />
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => {
                            setDeleteIndex(idx);
                            setDeleteModal(true);
                          }}
                          title="Delete"
                        >
                          <MdDelete size={16} />
                        </button>
                      </div>
                    </div>

                    {c.description && (
                      <div className="mb-2">
                        <small className="text-muted d-block">
                          Description
                        </small>
                        <span className="small">{c.description}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default RouteInfo;
